import { stageColor } from "@/lib/palette";
import { displayStage } from "@/lib/workspace";

export default function StageSpine({ templates, counts, onPick, focusedStage }) {
  return (
    <div
      data-testid="stage-spine"
      className="px-4 sm:px-6 lg:px-8 py-3 bg-[#E5EAF2] border-y border-[#15233B]/10"
    >
      <div className="flex gap-1.5 overflow-x-auto hide-scrollbar pb-0.5">
        {templates.map((t) => {
          const count = counts[t.stage_number] || 0;
          const c = stageColor(t.stage_number);
          const isFocused = focusedStage === t.stage_number;
          return (
            <button
              key={t.stage_number}
              data-testid={`spine-pill-${t.stage_number}`}
              onClick={() => onPick(t.stage_number)}
              className={`group shrink-0 pl-1 pr-2.5 py-1 rounded-full text-[11px] font-bold whitespace-nowrap transition-all flex items-center gap-1.5 hover:-translate-y-0.5 shadow-sm hover:ring-2 hover:ring-[#FB923C]/60 ${
                isFocused ? "ring-2 ring-[#FB923C] -translate-y-0.5 shadow-md" : ""
              }`}
              style={{ backgroundColor: c.primary, color: c.text }}
            >
              <span
                className="text-[11px] font-mono font-extrabold leading-none px-1.5 py-1 rounded-full bg-white/95 shadow-inner"
                style={{ color: c.primary }}
              >
                {String(displayStage(t.stage_number)).padStart(2, "0")}
              </span>
              <span className="leading-none">{t.name}</span>
              <span className="text-[10px] font-extrabold leading-none px-1.5 py-0.5 rounded-full bg-black/15">
                {count}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
